//
//
//
//
//
//
//
//
//
//
//
//

import LocalStore from '@/utils/localStore';
import MHeader from '../../Header/Header.vue';
export default {
    components: {
        MHeader,
    },
    methods: {
        loginOut() {
            LocalStore.removeToken()
            LocalStore.removeUser()
            this.$store.commit('updateUserInfo', {});
            this.$router.replace('/smsLogin')
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/userCenter/SetUp/SetUp.vue